/* tslint:disable */
/* eslint-disable */
/**
 * MTX Brokerage API
 * Brokerage agent-facing API for dispositions, listings, and transactions
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface OfferSubmissionDocument
 */
export interface OfferSubmissionDocument {
    /**
     * 
     * @type {string}
     * @memberof OfferSubmissionDocument
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof OfferSubmissionDocument
     */
    offerId: string;
    /**
     * 
     * @type {string}
     * @memberof OfferSubmissionDocument
     */
    s3Path: string;
    /**
     * 
     * @type {string}
     * @memberof OfferSubmissionDocument
     */
    fileName: string;
    /**
     * 
     * @type {string}
     * @memberof OfferSubmissionDocument
     */
    contentType: string;
    /**
     * 
     * @type {string}
     * @memberof OfferSubmissionDocument
     */
    url: string;
    /**
     * 
     * @type {Date}
     * @memberof OfferSubmissionDocument
     */
    createdAt: Date;
    /**
     * 
     * @type {Date}
     * @memberof OfferSubmissionDocument
     */
    updatedAt: Date;
}

/**
 * Check if a given object implements the OfferSubmissionDocument interface.
 */
export function instanceOfOfferSubmissionDocument(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "id" in value;
    isInstance = isInstance && "offerId" in value;
    isInstance = isInstance && "s3Path" in value;
    isInstance = isInstance && "fileName" in value;
    isInstance = isInstance && "contentType" in value;
    isInstance = isInstance && "url" in value;
    isInstance = isInstance && "createdAt" in value;
    isInstance = isInstance && "updatedAt" in value;

    return isInstance;
}

export function OfferSubmissionDocumentFromJSON(json: any): OfferSubmissionDocument {
    return OfferSubmissionDocumentFromJSONTyped(json, false);
}

export function OfferSubmissionDocumentFromJSONTyped(json: any, ignoreDiscriminator: boolean): OfferSubmissionDocument {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
        'offerId': json['offer_id'],
        's3Path': json['s3_path'],
        'fileName': json['file_name'],
        'contentType': json['content_type'],
        'url': json['url'],
        'createdAt': (new Date(json['created_at'])),
        'updatedAt': (new Date(json['updated_at'])),
    };
}

export function OfferSubmissionDocumentToJSON(value?: OfferSubmissionDocument | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'offer_id': value.offerId,
        's3_path': value.s3Path,
        'file_name': value.fileName,
        'content_type': value.contentType,
        'url': value.url,
        'created_at': (value.createdAt.toISOString()),
        'updated_at': (value.updatedAt.toISOString()),
    };
}

